import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
const footerAsideStyles = ({ theme }) => css `
	order: 1;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		order: initial;
	}
`;
export const StyledFooterAside = styled.aside `
	${footerAsideStyles}
`;
